import $Event from "./event"


export type EventTypes = {
    CONSULT_POPUP: boolean
}
const $bus = new $Event<EventTypes>()
export default $bus